export default class ResetPasswordFromPinService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  changePasswordFromPin(credentials) {
    return this.$http.post('/api/account/password_reset_from_pin', credentials);
  }
}



// WEBPACK FOOTER //
// ./components/auth/reset-password-frompin/reset-password-frompin.service.js